/**
 * Toggle the active class on the hamburger
 * Set navigation and navigationActive strings to your used classes
 */
export const initNavigation = function() {
  let hamburger = $('.c-hamburger');

  $(window).on('opened.zf.offcanvas', function () {
    hamburger.addClass('is-active');
  });

  $(window).on('closed.zf.offcanvas', function () {
    hamburger.removeClass('is-active');
  });
};